import { RegisterClick } from '@/services/register-click/index.api'
import * as React from 'react'
import { useLocation } from 'react-router'
import { Box } from '@mui/material'
import ClipLoader from 'react-spinners/ClipLoader'
import { Button } from '@components'
import styled from 'styled-components'

interface IRegisterClickProps {}

const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  gap: 24px;
`

const Message = styled.h6`
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: #5c5c5c;
  margin: 0;
  text-align: center;
`

const ErrorMessage = styled.h6`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #ff0000;
  margin: 0;
  text-align: center;
`

const RegisterClickPage: React.FC<IRegisterClickProps> = (props) => {
  const location = useLocation()
  const [error, setError] = React.useState<string | null>(null)
  const [isLoading, setIsLoading] = React.useState(true)

  const handleRedirect = React.useCallback(async () => {
    setError(null)
    setIsLoading(true)

    try {
      const clickType = location.pathname.includes('data-valuation')
        ? 'dataValuation'
        : 'dataBakedLending'

      const response = await RegisterClick({ clickType })

      if (response.data?.url) {
        window.location.href = response.data.url
      } else {
        setError('No redirect URL received from server')
        setIsLoading(false)
      }
    } catch (err) {
      setError('Failed to get redirect URL. Please try again.')
      setIsLoading(false)
    }
  }, [location.pathname])

  React.useEffect(() => {
    handleRedirect()
  }, [handleRedirect])

  if (error) {
    return (
      <Container>
        <ErrorMessage>{error}</ErrorMessage>
        <Button variant="primary" onClick={handleRedirect} width="200px">
          RETRY
        </Button>
      </Container>
    )
  }

  return (
    <Container>
      <ClipLoader color="#000000" size={40} />
      <Message>Redirecting...</Message>
    </Container>
  )
}

export default RegisterClickPage
